import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CompanyRegistrationHeader from '../components/Service/Consultation/CompanyRegistrationHeader';
import CompanyRegistrationInfo from '../components/Service/HrRecruitment/CompanyRegistrationInfo';
import ConditionsForRegister from '../components/Service/HrRecruitment/ConditionsForRegister';
import RegistrationProcess from '../components/Service/HrRecruitment/RegistrationProcess';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';
import SchoolBasedTour from '../components/Service/ConsultationForm/SchoolBasedTour';

export default function ConsultationSchoolBasedTour() {
    const [activity, setActivity] = useState({});
    return (
        <>
            <Header />
            <CompanyRegistrationHeader activity={activity} />
            <SchoolBasedTour activity={activity} setActivity={setActivity} />
            {/* <ConditionsForRegister /> */}
            {/* <RegistrationProcess /> */}
            
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}
